import { DeferCondition } from '../common/common.js';
import { ComponentLoaderService } from './component-loader.service.js';
export function ComponentLoaderMixin(Base) {
    class ComponentLoader extends Base {
        static { this.deferAttributeValueList = Object.values(DeferCondition).map((condition) => `defer:on:${condition}`); }
        get appliedDeferAttribute() {
            const attrs = Array.from(this.attributes).map((attr) => attr.name);
            return (ComponentLoader.deferAttributeValueList.find((condition) => attrs.includes(condition)) || '');
        }
        static { this.noDeferAttributes = [
            'defer:on:none',
            'defer:on:immediate',
        ]; }
        get allowInstantDefer() {
            if (!this.appliedDeferAttribute) {
                return true;
            }
            return ComponentLoader.noDeferAttributes.includes(this.appliedDeferAttribute);
        }
        constructor(...args) {
            super(...args);
            this.initialized = false;
            this.componentLoaderService = new ComponentLoaderService();
            this.deferAttributeList = [];
        }
        willUpdate(_changedProperties) {
            super.willUpdate(_changedProperties);
            this.componentLoaderService.addComponent(this);
            if (this.componentLoaderService.getDeferCondition(this)) {
                this.hydrate();
                return;
            }
            if (this.allowInstantDefer) {
                this.componentLoaderService.setDeferHandler(this);
                this.hydrate();
                return;
            }
            this.componentLoaderService.setDeferHandler(this).then(() => {
                if (!this.initialized) {
                    this.hydrate();
                    this.requestUpdate();
                }
            });
        }
        /**
         * If the component has a defer attribute defined, register it to the component
         * loader service and set the defer handler.
         *
         * Else initialize the component
         * @returns
         */
        connectedCallback() {
            super.connectedCallback();
            if (!this.allowInstantDefer) {
                this.componentLoaderService.setDeferHandler(this).then(() => {
                    if (!this.initialized) {
                        this.hydrate();
                        this.requestUpdate();
                    }
                });
                return;
            }
            this.hydrate();
        }
        hydrate() {
            this.initialize();
        }
        initialize() {
            this.initialized = true;
            return;
        }
    }
    return ComponentLoader;
}
//# sourceMappingURL=component-loader.js.map